'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of bar chart
 */ const BarChart = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3481_503)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M73.9829 38.2747C75.0234 39.1135 76.3272 39.6377 77.7634 39.6377C81.1046 39.6377 83.8228 36.9182 83.8228 33.5783C83.8228 30.2383 81.1033 27.5176 77.7634 27.5176C74.4235 27.5176 71.704 30.237 71.704 33.577C71.704 34.2899 71.8505 34.9656 72.0778 35.6028L64.36 41.0828C63.3195 40.244 62.0157 39.7199 60.5795 39.7199C59.1433 39.7199 57.8382 40.244 56.799 41.0828L49.0799 35.6015C49.3073 34.9656 49.4537 34.2899 49.4537 33.577C49.4537 30.2358 46.7342 27.5176 43.3943 27.5176C40.0544 27.5176 37.3349 30.237 37.3349 33.577C37.3349 34.2899 37.4814 34.9656 37.7087 35.6015L29.9897 41.0828C28.9491 40.244 27.6453 39.7199 26.2091 39.7199C22.8679 39.7199 20.1484 42.4393 20.1484 45.7793C20.1484 49.1192 22.8679 51.8387 26.2078 51.8387C29.5478 51.8387 32.2672 49.1192 32.2672 45.7793C32.2672 45.0663 32.1208 44.3906 31.8934 43.7548L39.6125 38.2734C40.653 39.1123 41.9569 39.6364 43.393 39.6364C44.8292 39.6364 46.1343 39.1123 47.1736 38.2734L54.8926 43.7548C54.6653 44.3906 54.5188 45.0663 54.5188 45.7793C54.5188 49.1205 57.2383 51.8387 60.5782 51.8387C63.9181 51.8387 66.6376 49.1192 66.6376 45.7793C66.6376 45.0663 66.4912 44.3906 66.2638 43.7535L73.9816 38.2734L73.9829 38.2747Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M30.1436 58.0234H22.2537C21.3477 58.0234 20.6133 58.7579 20.6133 59.6639V75.0211C20.6133 75.9271 21.3477 76.6615 22.2537 76.6615H30.1436C31.0496 76.6615 31.784 75.9271 31.784 75.0211V59.6639C31.784 58.7579 31.0496 58.0234 30.1436 58.0234Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M64.5186 58.0234H56.6287C55.7227 58.0234 54.9883 58.7579 54.9883 59.6639V75.0211C54.9883 75.9271 55.7227 76.6615 56.6287 76.6615H64.5186C65.4246 76.6615 66.159 75.9271 66.159 75.0211V59.6639C66.159 58.7579 65.4246 58.0234 64.5186 58.0234Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M47.3389 45.8223H39.449C38.543 45.8223 37.8086 46.5567 37.8086 47.4627V75.0222C37.8086 75.9282 38.543 76.6626 39.449 76.6626H47.3389C48.2449 76.6626 48.9794 75.9282 48.9794 75.0222V47.4627C48.9794 46.5567 48.2449 45.8223 47.3389 45.8223Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M81.7048 45.8223H73.8123C72.9063 45.8223 72.1719 46.5567 72.1719 47.4627V75.0222C72.1719 75.9282 72.9063 76.6626 73.8123 76.6626H81.7048C82.6108 76.6626 83.3452 75.9282 83.3452 75.0222V47.4627C83.3452 46.5567 82.6108 45.8223 81.7048 45.8223Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3481_503",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "63.6744",
                        height: "49.1483",
                        fill: "white",
                        transform: "translate(20.1484 27.5176)"
                    })
                })
            })
        ]
    });
};

exports.BarChart = BarChart;
//# sourceMappingURL=BarChart.cjs.map
